var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7 19.7615C27.7 21.9879 28.6537 24.0894 30.3169 25.5271C30.7547 25.9107 31 26.4552 31 27.0312C31 28.1169 30.1365 29 29.075 29H10.925C9.8635 29 9 28.1169 9 27.0312C9 26.4552 9.2453 25.9107 9.6732 25.5361C11.3463 24.0894 12.3 21.9879 12.3 19.7615V16.625C12.3 12.6661 15.1743 9.389 18.9 8.84V7.625C18.9 7.00288 19.3928 6.5 20 6.5C20.6072 6.5 21.1 7.00288 21.1 7.625V8.84C24.8246 9.389 27.7 12.6661 27.7 16.625V19.7615ZM24.0415 30.125C23.6587 32.0476 21.9922 33.5 20.0001 33.5C18.008 33.5 16.3415 32.0476 15.9587 30.125H24.0415Z",
    fill: "#278B9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.0826429502f34a4258285d76cce27928.svg";
export { ForwardRef as ReactComponent };